module.exports = __webpack_public_path__ + "static/d-KBarba-1634c9f5339966764b4ec052cf9fbf9b.jpg";